import React from 'react'
import GriData from './GriData';
import useFetch from '../../hooks/useFetch';

export default function GRI() {

  const { data, isLoading } = useFetch('gri')

  if (isLoading) {
    return (
      <>
        <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <h1 className="h2"><i className="fa-solid fa-spinner fa-spin"></i></h1>
          </div>
        </main>
      </>
    )
  }

  return (
    <>
      <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
          <h1 className="h2">GRI Report</h1>
        </div>
        <div className="table-responsive">
          <table className="table table-striped table-sm">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Year</th>
                <th scope="col">Category</th>
                <th scope="col">Source</th>
                <th scope="col">Supplier</th>
                <th scope="col">Location</th>
                <th scope="col">Ground water</th>
                <th scope="col">Surface water</th>
                <th scope="col">Sea water</th>
                <th scope="col">Third party</th>
                <th scope="col">Produced</th>
                <th scope="col">Muncipal solid waste</th>
                <th scope="col">Non hazardous waste</th>
                <th scope="col">Hazardous waste</th>
                <th scope="col">Used oil</th>
                <th scope="col">Wood waste</th>
                <th scope="col">Metal waste</th>
                <th scope="col">E waste</th>
                <th scope="col">Universal waste</th>
                <th scope="col">Discription</th>
                <th scope="col">Total employee</th>
                <th scope="col">Overall turnover rate</th>
                <th scope="col">New employee</th>
                <th scope="col">Unit</th>
                <th scope="col">Total</th>
              </tr>
            </thead>
            <tbody>
              <GriData data={data} />
            </tbody>
          </table>
        </div>



      </main>
    </>
  )
}
